import React, { useState } from "react";
import axios from "axios";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { API_BASE_URL, LOGIN } from '../services/apiConfig';
import SetMealTwoToneIcon from '@mui/icons-material/SetMealTwoTone';
import { useNavigate } from "react-router-dom";
import { TIEMPOEXPIRACIONCOOKIEENMINUTOS } from '../services/apiConfig.js';

function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    axios
      .post(API_BASE_URL + LOGIN, {
        email: email,
        password: password,
      })
      .then((response) => {
        console.log(response);
        if (response.data.status === "success") {
          sessionStorage.setItem("loggedIn", true);
          sessionStorage.setItem("userData",JSON.stringify(response.data.data));
          const maxAge = TIEMPOEXPIRACIONCOOKIEENMINUTOS * 60; // Convertir minutos a segundos
          document.cookie = `token=${response.data.token}; max-age=${maxAge}; HttpOnly; Secure; SameSite=Strict`;
          const expiryTime = new Date().getTime() + maxAge * 1000;
          sessionStorage.setItem("authToken", response.data.token);
          sessionStorage.setItem("expiryTime", expiryTime);

          navigate("/dashboard");
        
        } else {
          setError(response.data.message);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "5%",
      }}
    >
      <Container maxWidth="sm">
        <form onSubmit={handleSubmit}>
         
          {error && (
            <Alert style={{ marginBottom: "20px" }} severity="error">
              {error}
            </Alert>
          )}

          <img
            src="/sushi.png"
            alt="Sushi"
            style={{ maxWidth: '100%', height: 'auto' }}
          />

          
          <TextField
            type="email"
            value={email}
            onChange={handleEmailChange}
            variant="filled"
            id="email"
            label="Email "
            fullWidth
            style={{ marginBottom: "20px" }}
          />
          <TextField
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={handlePasswordChange}
            variant="filled"
            id="password"
            label="Password"
            fullWidth
            style={{ marginBottom: "20px" }}
            InputProps={{
              endAdornment: (
                <IconButton onClick={handleShowPassword}>
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              ),
            }}
          />
          <Button variant="contained" type="submit">
            Login
          </Button>
          {/* <p>
              No tenes cuenta? <Link href="/register">Registrate</Link>
            </p> */}
        </form>
      </Container>
    </Box>
  );
}

export default Login;


